import React from 'react';
import Popup from 'src/@vymo/ui/blocks/popup';
import classNames from 'classnames';
import { ReactComponent as TooltipIcon } from 'src/assets/icons/tooltip.svg';
import { TooltipProps } from './types';
import styles from './index.module.scss';

function Tooltip({
  content,
  placement = 'top',
  children,
  showIcon = true,
  tooltipClass = '',
  tooltipContentClass = '',
}: TooltipProps) {
  const tooltipClasses = classNames(styles.tooltip, tooltipClass);
  const tooltipContentClasses = classNames(
    styles.tooltip_content,
    tooltipContentClass,
  );
  const renderPopup = (popupChild: React.ReactNode) => (
    <Popup
      content={content}
      popupClass={tooltipClasses}
      className={tooltipContentClasses}
      openTrigger="hover"
      closeTrigger="hover"
      placement={placement}
    >
      {popupChild}
    </Popup>
  );

  if (showIcon) {
    return (
      <div className={tooltipClasses}>
        {children}
        {renderPopup(<TooltipIcon />)}
      </div>
    );
  }

  return renderPopup(<div className={tooltipClasses}>{children}</div>);
}

export default Tooltip;
